<template>
  <div>
    <h3 class="tw-mx-0 tw-my-2.5 tw-text-center tw-text-3xl tw-text-gray-700">No Reviews</h3>
    <h6 class="tw-mx-auto tw-mb-10 tw-mt-5 tw-max-w-xl tw-text-center tw-text-sm tw-font-light tw-text-gray-400">
      There are no reviews to show. Once a customer leaves a review it will be displayed here.
    </h6>
  </div>
  <div class="tw-text-center">
    <img class="tw-inline tw-w-1/2 tw-max-w-md" :src="imageUrl" />
  </div>
</template>

<script setup>
const imageUrl = asset(`/assets/site/images/svg/undraw_celebration_0jvk.svg`);
</script>
